export interface ITwilioParams {
  areaCode: number
  name: string
  countryCode: 'US' | 'CA'
  alphaNumericSenderId?: string
  forwardingNumber?: string
}

export interface ITwilioConfiguration {
  twilioAccountSid: string
  twilioAuthToken: string
  /**
   * The phone number from which to send outbound notifications.
   */
  twilioFrom: string
  /**
   * A list of fallback phone numbers to try if an outbound notification fails to be sent.
   */
  twilioFromFallback?: string[]
  twilioApiKey?: string
  twilioApiSecret?: string
  twilioApplicationId?: string
  /**
   * A phone number that can be used to forward inbound calls if we are unable to handle them ourselves.
   */
  forwardingNumber?: string
  twilioConversationServiceSid?: string
  /**
   * Outbound calls should be made from this number rather than twilioFrom.
   */
  twilioCallFrom?: string
  twilioVerifyServiceSid?: string
}

export interface IMessageBirdConfiguration {
  messageBirdFrom: string
  messageBirdApiKey: string
}

export enum NotificationProviderType {
  Twilio = 'twilio',
  MessageBird = 'messageBird',
}
interface INotificationProviderTemplate {
  type: NotificationProviderType
}
export interface INotificationProviderTwilio extends ITwilioConfiguration, INotificationProviderTemplate {
  type: NotificationProviderType.Twilio
}
export interface INotificationProviderMessageBird extends IMessageBirdConfiguration, INotificationProviderTemplate {
  type: NotificationProviderType.MessageBird
}

export type INotificationProvider = INotificationProviderTwilio | INotificationProviderMessageBird

export type IClientSafeTwilioConfiguration = Omit<
  INotificationProviderTwilio,
  'twilioAuthToken' | 'twilioApiSecret' | 'twilioApiKey'
>
export type IClientSafeMessageBirdConfiguration = Omit<INotificationProviderMessageBird, 'messageBirdApiKey'>

export type INotificationProviderGetResponse = Array<
  IClientSafeTwilioConfiguration | IClientSafeMessageBirdConfiguration
>

export type ITwilioPatchBody = ITwilioParams
export type ITwilioPatchResponse = IClientSafeTwilioConfiguration
